<template>
  <div>
      <h3>
          Fire Alarm Monthly Testing Record (Reference Clauses 5.2.1, CAN/ULC-S536-97)
      </h3>
      <h4>
          Legend
      </h4>
      <p>
            1A.  System Trouble Signal Indicator 'OFF'.
            <br>
            1B.  Power Indication Lamp 'ON'.
            <br>
            2A.  Operation and Inspection of one initiating field device - Rotational
            <br>
            2B.  Satisfactory Alert/Alarm Signal confirmed - Rotational
            <br>
            2C.  Inspect (Required Annunciator):  Tested device annunciates correctly.
            <br>
            2D.  Satisfactory operation of common audible and visual trouble signal.  
            <br>
            3A.  Terminals Cleaned and lubricated.
            <br>
            3B.  Terminal clamps secure
            <br>
            3C.  Electrolyte level and specific gravity to specifications
            <br>
            4A.  Test (rotational):  One emergency telephone for two-way communication and indication
            <br>
            4B.  Test (rotational):  Voice paging to one zone.
            <br>
            *  Fire Code regulations require that these records be retained a minimum of two years. 
            <br>
            *  Tests to be conducted in accordance with CAN/ULC-S536 and Ontario Fire Code.
            <br>
            *  The monthly test is not required during the month  that the annual test is completed.
            <br>
            <b>NOTES
            <br>
            1. National Fire Code of Canada requires that these records be retained a minimum of two (2) years.
            <br>
            2. Tests to be conducted in accordance with this Standard (CAN/ULC-S536) while on emergency power.
            <br>
            3. The monthly test is not required during the month that the annual test is completed. </b>
      </p>
  </div>
</template>

<script>
export default {
    name : 'AFAS_3_Monthly',

}
</script>

<style>

</style>